import cn from "clsx";

import type { AdvertoryTargetId } from "../Advertory/types";
import type { CardsResponse } from "../../types/content";
import type { FeedItems } from "../../types/content/feedItem";
import type { ListView } from "../../types/webTypes";
import type { SponsoredBannerData } from "../../types/ads/sponsoredBanner";

import { AdvertorySlot } from "../Advertory/AdvertorySlot";
import { StickySideAd } from "../StickySideAd/StickySideAd";
import { Cards } from "../Cards/Cards";
import styles from "./Feed.module.scss";
import { LatestNewsLayout } from "./LatestNewsLayout/LatestNewsLayout";
import { ListLayout } from "./ListLayout/ListLayout";
import { TopNewsLayout } from "./TopNewsLayout/TopNewsLayout";

const Feed = ({
  data,
  advertoryWidescreenTargetId,
  sponsoredBannerData,
  isFirstFeed,
  layoutType,
  listView,
  endOfFeed,
  headerTitle,
  isLoggedIn = false,
  cards,
}: {
  data: FeedItems;
  cards?: CardsResponse;
  isLoggedIn?: boolean;
  advertoryWidescreenTargetId?: Extract<
    AdvertoryTargetId,
    "widescreen_1" | "widescreen_2"
  >;
  sponsoredBannerData?: SponsoredBannerData | null;
  isFirstFeed?: boolean;
  layoutType: "top" | "latest" | "list";
  listView?: ListView;
  endOfFeed?: boolean;
  headerTitle?: string;
}) => {
  const hasFeedData = !!data?.length;
  const hasWidescreenAd = Boolean(advertoryWidescreenTargetId);
  const cardsIsAllowedToRender = isFirstFeed && cards && layoutType !== "list";

  return (
    <div
      className={cn([
        styles.feedContainer,
        hasWidescreenAd && styles.withWidescreenAd,
        isFirstFeed && styles.firstFeed,
        layoutType === "latest" && !isFirstFeed && styles.combineFeeds,
      ])}
    >
      <div
        className={cn([styles.feed, endOfFeed && styles.endOfFeed])}
        data-fss-mask-root="true"
      >
        {cardsIsAllowedToRender && (
          <Cards
            cards={cards}
            viewType={layoutType === "latest" ? "latest" : "top"}
          />
        )}
        {layoutType === "top" && (
          <TopNewsLayout
            isLoggedIn={isLoggedIn}
            data={data}
            isFirstFeed={isFirstFeed}
          />
        )}
        {layoutType === "latest" && (
          <LatestNewsLayout
            isLoggedIn={isLoggedIn}
            data={data}
            isFirstFeed={isFirstFeed}
          />
        )}
        {layoutType === "list" && (
          <ListLayout
            listView={listView!}
            isFirstFeed={isFirstFeed}
            data={data}
            sponsoredBannerData={sponsoredBannerData}
            endOfFeed={endOfFeed}
            headerTitle={headerTitle}
          />
        )}
      </div>
      {hasFeedData && advertoryWidescreenTargetId ? (
        <StickySideAd hasBottomGradientStyle={isFirstFeed}>
          <AdvertorySlot
            device="desktop"
            targetId={advertoryWidescreenTargetId}
          />
        </StickySideAd>
      ) : null}
    </div>
  );
};

export { Feed };
